import script from "./quick-images.vue?vue&type=script&setup=true&lang=js"
export * from "./quick-images.vue?vue&type=script&setup=true&lang=js"

import "./quick-images.vue?vue&type=style&index=0&id=8da36136&lang=scss&scoped=true"

import exportComponent from "/Users/xujunfeng/Desktop/project/school/digital_factory_server/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8da36136"]])

export default __exports__